angular
	.module 'App.Repository'
	.factory 'ProductTranslationRepository', [
		'BaseRepository',
		(BaseRepository) ->
			class ProductTranslationRepository extends BaseRepository
				@resource = '/product_translations'
				@isRestricted = true

			return new ProductTranslationRepository
	]
